import { UseQueryResult } from '@tanstack/react-query';
import { useSession } from '../SessionProvider';
import { useTrackedQuery as useQuery } from '@ais-ui/performance-tracking';

import {
  checkForNewEvents,
  EventsResponse,
  getCurrentEvents,
  getEventsForPeriod,
} from './getEvents';
import { convertFieldsToDates } from '@ais-ui/utils';

export const useGetEvents = (): UseQueryResult<EventsResponse> => {
  const { olSession } = useSession();

  return useQuery(['getCurrentEvents'], () => {
    return getCurrentEvents(olSession);
  });
};

export const useGetEventsForPeriod = (
  startDateTime: Date | undefined,
  endDateTime: Date | undefined
): UseQueryResult<EventsResponse> => {
  const { olSession } = useSession();

  // Convert dates to strings for stable query keys
  const startKey = startDateTime?.toISOString();
  const endKey = endDateTime?.toISOString();

  const isEnabled = startDateTime !== undefined && endDateTime !== undefined;

  return useQuery(
    ['getPeriodEvents', startKey, endKey],
    async () => {
      const response = await getEventsForPeriod(
        olSession,
        startDateTime as Date,
        endDateTime as Date
      );

      if (response) {
        convertFieldsToDates(response, [
          'endDateTime',
          'endTime',
          'startDateTime',
          'startTime',
          'events.activated',
          'events.act_ts',
          'events.deactivated',
          'events.deact_ts',
          'events.ack_state_modified_ts',
        ]);
      }

      return response;
    },
    {
      enabled: isEnabled,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore - TypeScript has issues with placeholderData typing in v4
      placeholderData: (previousData) => previousData,
    }
  );
};

export const useCheckForNewEvents = () => {
  const { olSession } = useSession();
  return useQuery(['checkForNewEvents'], () => checkForNewEvents(olSession), {
    refetchInterval: 15000,
  });
};
